import { Calculator } from 'shared/components/Calculator';
import { SubsidizedMortgageContainer } from '../microfrontends/SubsidizedMortgageCalculator';

export const CalculatorContainer: React.FC = () => {
  return <Calculator microfrontendCalculator={<SubsidizedMortgageContainer />} />;
};
